var React = require('react');

function IconReportAttribution (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18 0C8.1 0 0 8.1 0 18s8.1 18 18 18 18-8.1 18-18S27.9 0 18 0zm0 32.6C10 32.6 3.4 26 3.4 18S10 3.4 18 3.4 32.6 10 32.6 18 26 32.6 18 32.6z","key":0}),React.createElement("path",{"d":"M9 11.9v5.9c0 .7.3 1.3.8 1.8l7.2 6.9c1 1 2.7 1 3.7 0l5.5-5.3c1-1 1-2.6 0-3.6L19 10.7c-.5-.5-1.2-.7-1.9-.7H11c-1.1 0-2 .8-2 1.9zm4.6 3.8c-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3 1.3.6 1.3 1.3-.6 1.3-1.3 1.3z","key":1})]);
}

IconReportAttribution.defaultProps = {"xmlSpace":"preserve","style":{"enableBackground":"new 0 0 36 36"},"viewBox":"0 0 36 36"};

module.exports = IconReportAttribution;

IconReportAttribution.default = IconReportAttribution;
